import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AddCompanyComponent } from '../add-company/add-company.component';
import { TemplateService } from 'src/app/services/template/template.service';
import { FormControl, Validators } from '@angular/forms';
import { AdminService } from 'src/app/services/admin/admin.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { Router } from '@angular/router';
import { AddTemplateComponent } from '../add-template/add-template.component';
import { HttpService } from 'src/app/services/http/http.service';
import { AddResultTemplateComponent } from '../add-result-template/add-result-template.component';
import { Content } from '@angular/compiler/src/render3/r3_ast';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-campaign-setting',
  templateUrl: './campaign-setting.component.html',
  styleUrls: ['./campaign-setting.component.scss']
})
export class CampaignSettingComponent implements OnInit {
  items: any[] = [];
  letterPattern = '[A-Za-z]*';
  flag: boolean = true;
  // result: any = [];
  initial: any = '';
  template:any;
  status:boolean= false;
  
  shortName = new FormControl('', [Validators.required, Validators.pattern(this.letterPattern)]);
  toBeSearched: Object;
  templateList: any;
  resultTemplateList = [];
  landingTemplateList = [];
  count = 0;
  visibilityForLeftIcon = false;
  visibilityForRightIcon = true;

  constructor(private dialog: MatDialog,
    private templateService: TemplateService,
    private adminService: AdminService,
    private clipboardService: ClipboardService,
    private snackBarService: MatSnackBar,
    private utility:UtilityService,
    private router: Router,
    private httpService: HttpService) { }
  templates = [];
   
  ngOnInit() {
  // this.getTemplate();
    this.getCompanies();
   // console.log(this.router.url);
  }

  newCompany() {
  //  console.log('open');
   const dialogRef = this.dialog.open(AddCompanyComponent, {
     // disableClose: true,
      width: '600px',
     // height:'fit-content'
     panelClass: "dialog-style"
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result === 'Added'){
        this.ngOnInit();
      }
    })
  }
  // getTemplate() {
  //   this.templateService.getTemplate().subscribe(data => {
  //   this.templates = data['template'];
  //     console.log(this.templates);
  //   });
  // }

  getTemplate() {
    this.resultTemplateList = [];
    this.landingTemplateList = [];
    // this.status = !this.status;
    var contentBody = { url: '/templates'}
    this.httpService.httpGet(contentBody).subscribe(response => {
   //   console.log('response in getTemplates:',response);
      this.template = (response as any).data;
      for(let i=0; i < this.template.length; i++){
        if(this.template[i].templatePurpose === 'RESULT_TEMPLATE'){
          this.resultTemplateList.push(this.template[i]);
        }
        if(this.template[i].templatePurpose === 'LANDING_TEMPLATE'){
          this.landingTemplateList.push(this.template[i]);
        }
      }
   //   console.log("result",this.resultTemplateList);
   //   console.log("landing",this.landingTemplateList);
      
      
      
      // this.resultTemplateList = 
    //this.template=this.templateList;
  //    console.log("getTemplates:",this.template);
    })
}


// getTemplate1() {
//   this.status = !this.status;
//   var contentBody = { url: '/templates'}
//   this.httpService.httpGet(contentBody).subscribe(response => {
//     console.log('response in getTemplates:',response);
//     this.template = (response as any).data;
//     console.log("getTemplates:",this.template);
//   })
// }



  getCompanies(){
    this.adminService.getCompanies()
    .subscribe(response =>{
   //   console.log("response after getting companies: ", response);
      
      this.items = response as any;
      this.toBeSearched = response;

      this.items = this.items.map(data => {
        data.flag = true;
        return data;
      });
    });
  }
 
  getErrorMessageOfShortName() {
    return this.shortName.hasError('required') ? 'Enter Short Name' : this.shortName.hasError('pattern') ? 'Please Enter Valid Input' : '';
  }
  changeEditStatus(data){
    data.flag = false;
  }
  
  updateShortName(data){
    data.flag = true;

  //  console.log("data1",data)
    
    if(data.shortName.trim() === ''){
      this.utility.openSnackBar("ShortName Cannot Be Empty.");
      this.getCompanies();

    }else{
      this.adminService.updateCompany(data)
      .subscribe(response =>{
        this.ngOnInit();
      });
    }
  }

  validateShortName(item){
  //  console.log(item.shortName); 
  }





  addTemplate(){
  // console.log('open');
    const dialogRef = this.dialog.open(AddTemplateComponent, {
       disableClose: true,
       width: '500px',
       panelClass: "dialog-style"
     });
     dialogRef.afterClosed().subscribe(result => {
      if(result != null){
        this.getTemplate();
        }
     })
  }

  addResultTemplate(){
   // console.log('open');
    const dialogRef = this.dialog.open(AddResultTemplateComponent, {
       disableClose: true,
       width: '500px',
       panelClass: "dialog-style",
     //  height:'fit-content'
     });
     dialogRef.afterClosed().subscribe(result => {
       if(result != null){
       this.getTemplate();
       }
     })
  }

  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;

  public scrollRight(length): void {
  //  console.log("Length", length);
    this.count++;
    if (this.count + 2 === length - 1) {
    //  console.log("this.count", this.count + 2);
    //  console.log("Length", length);
      this.visibilityForRightIcon = false;
      this.visibilityForLeftIcon = true;
    }
    else {
      this.visibilityForLeftIcon = true;
    }

    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 350), behavior: 'smooth' });
    // this.widgetsContent.nativeElement.scrollTo({ right: (this.widgetsContent.nativeElement.scrollRight + 270), behavior: 'smooth' });
  }

  public scrollLeft(length): void {
    this.count--;
    if (this.count + 2 === 2) {
      this.visibilityForLeftIcon = false;
      this.visibilityForRightIcon = true;
    }
    else {
      this.visibilityForRightIcon = true;
    }
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 350), behavior: 'smooth' });
  }




  copyUrl(url) {
    this.clipboardService.copyFromContent(url);
    this.snackBarService.open('Copied to clipboard', '', { duration: 2000 });

  }


  makeEditable(value, index) {
    
  //  console.log("value:",value);
    
    if (value == 'time') {
      if (this.items[index].isEditable === false || this.items[index].isEditable === undefined) {
        for (let i = 0; i < this.items.length; i++) {
          this.items[i].isEditable = false
        }
        this.items[index].isEditable = true;
      }
      else {
        this.items[index].isEditable = false;
      }
    }
  }


  editShortName(data)
  {
   
  //  console.log("data",data)

    this.adminService.updateCompany(data)
    .subscribe(response =>{
  //    console.log("Response",response)
      this.utility.openSnackBar(" Company update successfully");
      this.ngOnInit();
    });

  }
  
}